export default "__VITE_ASSET__oD5nGCui__"